class Lazy {
  constructor() {
    const observer = new IntersectionObserver(this.callback)
    const targets = document.querySelectorAll('.lazy')

    targets.forEach(target => observer.observe(target))
  }

  callback(entries, observer) {
    entries.forEach(({ target, isIntersecting }) => {
      target.addEventListener('load', () => {
        target.classList.add('lazy--loaded')
      })

      if (isIntersecting) {
        target.dataset.src ? target.src = target.dataset.src :
        target.dataset.srcset ? target.srcset = target.dataset.srcset :
        target.dispatchEvent(new Event('load'))

        observer.unobserve(target)
      }
    })
  }
}

export default Lazy;
